import { type DomainAccessControlConfig } from '../../../utils/domain/accessControl'
import { Permission } from '../../../access-control/permissions'

export const caperBillingAccessControl: DomainAccessControlConfig = [
  {
    permissions: [Permission.CaperBillingView],
  },
]
